module.exports = __webpack_public_path__ + "img/draw.3d7f8b6b.png";